import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1080.000000 588.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,588.000000) scale(0.100000,-0.100000)"
        >
          <path d="M3401 3903 c-1 -31 -20 -38 -30 -11 -6 13 -10 17 -10 10 -1 -7 -9
-12 -18 -10 -14 2 -17 -3 -15 -22 2 -14 8 -27 14 -29 5 -2 18 -16 27 -32 l18
-30 13 60 c7 32 10 65 7 73 -3 7 -6 4 -6 -9z"/>
<path d="M3381 3894 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M3131 3694 l-40 -46 42 -32 c23 -18 43 -39 45 -48 2 -12 -42 -38
-173 -102 -96 -47 -178 -86 -181 -86 -5 0 -56 -48 -170 -157 -13 -13 -27 -23
-33 -23 -5 0 -11 -4 -13 -8 -1 -5 -28 -27 -58 -50 -30 -23 -59 -46 -65 -50 -5
-4 -27 -17 -47 -29 -29 -17 -38 -19 -38 -8 0 7 6 16 13 19 6 3 -1 3 -18 1 -16
-3 -24 -2 -17 1 9 4 3 17 -19 45 -17 21 -34 37 -39 34 -4 -3 -13 2 -20 10 -7
8 -20 15 -29 15 -13 0 -13 -2 -2 -9 10 -7 7 -9 -12 -8 -19 2 -23 5 -15 15 16
19 2 14 -41 -13 -110 -69 -272 -111 -400 -102 -135 9 -153 24 -23 19 67 -3
138 0 175 7 57 12 219 74 242 94 6 4 28 19 50 32 50 30 33 31 -48 4 -49 -17
-78 -20 -142 -16 -94 5 -165 34 -353 145 -142 85 -177 97 -229 83 -47 -13 -80
-42 -99 -88 -32 -76 9 -138 146 -216 97 -56 293 -172 373 -220 34 -21 105 -59
157 -85 81 -40 105 -47 168 -51 154 -7 291 61 576 289 69 54 153 125 186 157
34 32 66 58 71 58 4 0 54 -43 110 -95 56 -52 107 -96 113 -98 8 -2 18 37 30
120 10 68 29 190 43 271 24 149 27 202 8 202 -5 1 -21 7 -35 15 -26 15 -31 16
-52 19 -9 1 -8 4 2 11 10 6 4 8 -21 4 -22 -4 -39 -2 -43 5 -13 21 -34 11 -75
-35z m21 -62 c20 -20 4 -22 -22 -2 -19 14 -21 18 -7 16 9 -1 22 -7 29 -14z"/>
<path d="M3372 3700 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M9010 2960 l0 -540 100 0 100 0 0 170 c0 94 3 170 8 170 4 0 32 -32
62 -72 30 -39 90 -115 133 -169 l78 -99 119 0 c66 0 120 4 120 9 0 5 -48 69
-107 142 -59 74 -114 143 -123 153 -8 11 -32 39 -54 63 -21 23 -36 48 -33 55
2 7 75 93 162 190 86 97 156 180 156 183 -1 4 -55 8 -122 9 l-121 2 -130 -153
c-72 -84 -134 -153 -139 -153 -5 0 -9 128 -9 290 l0 290 -100 0 -100 0 0 -540z"/>
<path d="M6778 3328 c-3 -96 -4 -103 -23 -101 -11 2 -33 0 -48 -3 l-28 -6 3
-76 3 -77 48 -3 47 -3 0 -223 c0 -253 7 -290 68 -349 46 -45 124 -67 239 -67
l83 0 0 90 0 90 -73 0 c-110 0 -107 -7 -107 248 l0 212 90 0 91 0 -3 83 -3 82
-85 1 -85 2 -3 101 -3 101 -104 0 -104 0 -3 -102z"/>
<path d="M3698 3413 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z"/>
<path d="M4420 3413 c30 -3 58 -10 62 -16 5 -8 8 -6 8 6 0 15 -9 17 -62 15
l-63 -2 55 -3z"/>
<path d="M4622 3328 l2 -93 3 87 4 87 37 4 37 4 -42 1 -43 2 2 -92z"/>
<path d="M3571 3373 c0 -4 4 -17 9 -28 8 -19 9 -19 9 2 1 12 -3 25 -9 28 -5 3
-10 3 -9 -2z"/>
<path d="M3761 3364 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M4257 3302 c-21 -47 -23 -75 -4 -47 12 18 31 85 24 85 -2 0 -11 -17
-20 -38z"/>
<path d="M4803 3280 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z"/>
<path d="M2385 3300 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M2345 3270 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0
-13 -4 -16 -10z"/>
<path d="M4420 3270 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M4410 3224 c0 -8 5 -12 10 -9 6 3 10 10 10 16 0 5 -4 9 -10 9 -5 0
-10 -7 -10 -16z"/>
<path d="M6183 3225 c-79 -21 -127 -50 -162 -94 -52 -65 -64 -133 -36 -210 28
-81 99 -122 291 -171 130 -33 154 -49 154 -104 0 -44 -32 -69 -98 -74 -78 -7
-136 18 -159 68 l-18 39 -103 1 -103 0 6 -37 c16 -91 100 -179 203 -210 68
-21 213 -23 287 -5 69 18 142 73 165 126 43 96 34 181 -26 241 -54 55 -123 83
-308 127 -85 20 -121 62 -98 113 14 31 79 49 141 40 48 -7 111 -58 111 -89 0
-14 15 -16 95 -16 l95 0 0 28 c-1 36 -35 110 -68 145 -76 81 -239 117 -369 82z"/>
<path d="M7519 3231 c-65 -13 -146 -60 -193 -112 -83 -92 -123 -263 -93 -394
48 -211 161 -307 362 -309 103 0 141 13 204 69 l41 37 0 -51 0 -51 100 0 100
0 0 400 0 399 -32 6 c-18 3 -62 5 -98 3 l-65 -3 -5 -47 -5 -46 -39 38 c-59 59
-167 82 -277 61z m199 -190 c56 -29 90 -68 107 -124 50 -169 -26 -311 -174
-324 -101 -9 -166 34 -206 140 -33 88 -5 224 58 280 55 49 150 61 215 28z"/>
<path d="M8454 3230 c-105 -22 -216 -107 -264 -200 -49 -96 -52 -290 -7 -392
51 -114 157 -196 285 -220 79 -15 202 2 270 36 86 44 163 140 174 218 3 22 1
23 -98 26 l-100 3 -25 -38 c-13 -21 -40 -46 -59 -55 -48 -25 -136 -24 -177 2
-128 78 -134 331 -10 421 69 50 188 36 235 -27 12 -16 27 -35 33 -42 7 -9 38
-12 107 -10 94 3 97 4 94 26 -12 85 -110 195 -207 231 -62 23 -190 34 -251 21z"/>
<path d="M4527 3213 c-3 -5 10 -8 29 -9 19 0 34 3 34 8 0 10 -57 11 -63 1z"/>
<path d="M4853 3214 c3 -3 32 -6 64 -6 l58 -1 6 -51 6 -51 1 58 2 57 -72 0
c-39 0 -69 -3 -65 -6z"/>
<path d="M5100 3209 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M5200 3210 c0 -13 11 -13 30 0 12 8 11 10 -7 10 -13 0 -23 -4 -23
-10z"/>
<path d="M5660 3213 c0 -5 28 -7 62 -5 113 5 125 9 31 10 -51 1 -93 -1 -93 -5z"/>
<path d="M2268 3203 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M4401 3184 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M5103 3135 c0 -33 2 -45 4 -27 2 18 2 45 0 60 -2 15 -4 0 -4 -33z"/>
<path d="M4521 3128 c0 -32 2 -58 7 -58 4 0 6 19 4 43 -5 70 -10 76 -11 15z"/>
<path d="M5650 3121 c0 -23 5 -41 10 -41 6 0 10 15 10 34 0 19 -4 38 -10 41
-6 4 -10 -10 -10 -34z"/>
<path d="M3841 3124 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M3850 3095 c0 -5 5 -17 10 -25 5 -8 10 -10 10 -5 0 6 -5 17 -10 25
-5 8 -10 11 -10 5z"/>
<path d="M4184 3073 c-4 -15 -13 -38 -20 -52 -8 -14 -14 -33 -13 -41 0 -13 1
-13 6 0 3 8 11 29 18 45 18 41 27 75 21 75 -3 0 -9 -12 -12 -27z"/>
<path d="M3684 3048 c8 -18 20 -48 27 -66 15 -43 22 -35 8 9 -21 65 -31 89
-40 89 -5 0 -2 -15 5 -32z"/>
<path d="M4568 3073 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M4618 2928 c4 -286 8 -313 10 -80 1 127 -1 232 -5 232 -5 0 -7 -69
-5 -152z"/>
<path d="M2915 3037 c-39 -29 -83 -77 -91 -100 -4 -12 -12 -16 -27 -13 -12 3
-16 3 -9 0 20 -9 15 -19 -34 -68 -47 -46 -71 -59 -61 -31 9 21 -14 31 -25 11
-5 -9 -15 -16 -22 -16 -7 0 -41 -18 -75 -40 -137 -89 -237 -123 -345 -119 -39
2 -82 9 -96 16 -14 7 -29 13 -35 13 -15 0 -250 130 -253 141 -2 5 -8 9 -14 9
-5 0 -43 20 -84 45 -40 25 -76 45 -78 45 -3 0 -31 16 -63 35 -39 24 -70 35
-96 35 -109 0 -170 -104 -116 -199 16 -28 48 -52 147 -109 70 -40 134 -77 142
-82 405 -247 474 -277 599 -268 77 6 138 36 413 206 131 81 261 161 288 177
119 73 139 150 67 256 -14 22 -88 80 -99 79 -2 0 -16 -11 -33 -23z"/>
<path d="M5104 2865 c0 -110 2 -156 3 -103 2 53 2 143 0 200 -1 57 -3 13 -3
-97z"/>
<path d="M4326 2985 c-3 -9 -6 -24 -5 -33 0 -9 5 -4 10 12 9 32 6 48 -5 21z"/>
<path d="M4141 2934 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M3922 2890 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M4291 2884 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M2710 2865 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2 0
-9 -7 -16 -15z"/>
<path d="M5283 2800 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z"/>
<path d="M3777 2809 c4 -13 8 -18 11 -10 2 7 -1 18 -6 23 -8 8 -9 4 -5 -13z"/>
<path d="M4076 2764 c-4 -14 -5 -28 -3 -31 3 -2 8 8 11 23 4 14 5 28 3 31 -3
2 -8 -8 -11 -23z"/>
<path d="M5282 2730 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M4241 2724 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M4205 2650 c-4 -17 -5 -34 -2 -36 3 -3 8 9 12 26 4 17 5 34 2 36 -3
3 -8 -9 -12 -26z"/>
<path d="M4801 2664 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M5627 2663 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z"/>
<path d="M5111 2634 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M3850 2595 c0 -5 5 -17 10 -25 5 -8 10 -10 10 -5 0 6 -5 17 -10 25
-5 8 -10 11 -10 5z"/>
<path d="M2900 2572 c-20 -10 -83 -49 -140 -87 -58 -37 -127 -83 -155 -100
-82 -53 -206 -115 -264 -132 -69 -20 -167 -13 -236 17 -49 21 -208 106 -295
158 -222 132 -254 147 -309 146 -49 0 -56 -3 -92 -41 -46 -50 -56 -84 -39
-132 17 -48 43 -69 180 -148 127 -73 330 -190 418 -241 186 -107 301 -123 437
-63 44 19 470 274 593 354 113 75 134 177 51 251 -45 42 -91 47 -149 18z"/>
<path d="M4885 2585 c23 -8 83 -10 79 -3 -3 4 -24 8 -47 7 -23 0 -37 -2 -32
-4z"/>
<path d="M5460 2580 l-45 -7 53 -1 c29 -1 52 2 52 8 0 6 -3 9 -7 8 -5 0 -28
-4 -53 -8z"/>
<path d="M5150 2561 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z"/>
<path d="M3882 2505 c15 -38 28 -54 28 -34 0 7 -9 25 -20 39 l-21 25 13 -30z"/>
<path d="M4983 2480 c0 -30 2 -43 4 -27 2 15 2 39 0 55 -2 15 -4 2 -4 -28z"/>
<path d="M5600 2498 c-12 -22 -12 -22 6 -6 10 10 15 20 12 24 -4 3 -12 -5 -18
-18z"/>
<path d="M5656 2481 c-4 -5 -2 -20 3 -33 9 -21 10 -21 10 10 1 32 -3 39 -13
23z"/>
<path d="M5244 2466 c11 -9 24 -16 30 -16 12 0 7 5 -24 19 -24 11 -24 11 -6
-3z"/>
<path d="M4744 2455 c36 -19 42 -19 26 0 -7 8 -22 15 -34 15 -18 0 -17 -2 8
-15z"/>
<path d="M5308 2433 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5455 2430 c-13 -5 -14 -9 -5 -9 8 0 24 4 35 9 13 5 14 9 5 9 -8 0
-24 -4 -35 -9z"/>
<path d="M6950 2200 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M7134 2197 c-3 -8 -3 -39 -1 -68 l3 -54 4 65 3 65 7 -55 7 -55 1 52
c2 50 -12 80 -24 50z"/>
<path d="M7995 2200 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M8910 2195 c-20 -25 -6 -31 17 -7 14 14 18 22 9 22 -8 0 -19 -7 -26
-15z"/>
<path d="M3900 2188 c3 -3 25 -15 50 -27 41 -20 43 -21 25 -3 -11 11 -33 23
-50 27 -16 3 -28 5 -25 3z"/>
<path d="M4330 2180 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M6846 2166 c21 -15 30 -14 19 3 -3 6 -14 11 -23 11 -13 0 -13 -2 4
-14z"/>
<path d="M7790 2169 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M4322 2131 c-11 -7 -11 -9 2 -14 10 -4 16 -1 16 8 0 17 -1 17 -18 6z"/>
<path d="M4351 2124 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M3990 2120 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M4180 2126 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
<path d="M4235 2120 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M4626 2117 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z"/>
<path d="M5315 2120 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M5450 2126 c0 -2 7 -6 15 -10 8 -3 15 -1 15 4 0 6 -7 10 -15 10 -8 0
-15 -2 -15 -4z"/>
<path d="M5880 2119 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M5941 2110 c-31 -26 -17 -26 16 0 14 11 22 20 17 20 -5 -1 -20 -10
-33 -20z"/>
<path d="M6020 2119 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M9027 2110 c3 -11 7 -20 9 -20 2 0 4 9 4 20 0 11 -4 20 -9 20 -5 0
-7 -9 -4 -20z"/>
<path d="M9145 2120 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0
-13 -4 -16 -10z"/>
<path d="M7053 2080 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z"/>
<path d="M9116 2105 c-3 -8 -1 -15 4 -15 6 0 10 7 10 15 0 8 -2 15 -4 15 -2 0
-6 -7 -10 -15z"/>
<path d="M9460 2116 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z"/>
<path d="M6052 2085 c6 -14 13 -24 14 -22 6 6 -9 47 -17 47 -5 0 -3 -11 3 -25z"/>
<path d="M8360 2103 c0 -4 5 -15 10 -23 8 -13 10 -13 10 2 0 9 -4 20 -10 23
-5 3 -10 3 -10 -2z"/>
<path d="M4227 2080 c3 -11 9 -17 15 -14 5 3 4 12 -3 20 -16 19 -18 18 -12 -6z"/>
<path d="M4605 2090 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M7790 2086 c8 -7 31 -17 50 -20 19 -3 28 -3 20 0 -83 35 -85 35 -70
20z"/>
<path d="M4627 2077 c-4 -10 -7 -31 -6 -45 l0 -27 10 25 c5 13 8 33 7 45 -3
19 -4 19 -11 2z"/>
<path d="M5091 2074 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M6470 2063 c0 -10 4 -14 8 -8 4 6 11 13 16 18 5 4 2 7 -7 7 -10 0
-17 -8 -17 -17z"/>
<path d="M8812 2050 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z"/>
<path d="M4330 2039 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M5542 2010 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z"/>
<path d="M9332 2015 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M7320 2026 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
<path d="M4077 2013 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z"/>
<path d="M5123 2003 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"/>
<path d="M4472 1980 c7 -10 14 -18 15 -16 6 6 -9 36 -18 36 -5 0 -4 -9 3 -20z"/>
<path d="M3950 1969 c-19 -11 -28 -19 -19 -19 9 0 27 9 40 20 29 23 25 23 -21
-1z"/>
<path d="M5224 1971 c2 -14 9 -27 17 -29 11 -3 12 -2 1 6 -8 5 -13 12 -12 16
1 4 -1 12 -4 19 -2 6 -3 1 -2 -12z"/>
<path d="M7151 1974 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M9230 1965 c-7 -8 -8 -15 -2 -15 5 0 15 7 22 15 7 8 8 15 2 15 -5 0
-15 -7 -22 -15z"/>
<path d="M4100 1960 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M5560 1962 c0 -13 47 -28 57 -18 4 3 -3 6 -13 6 -11 0 -25 5 -32 12
-9 9 -12 9 -12 0z"/>
<path d="M6265 1960 c-4 -7 -24 -10 -45 -8 -21 2 -36 0 -34 -4 3 -5 20 -8 37
-8 34 0 66 15 55 25 -3 4 -9 1 -13 -5z"/>
<path d="M6830 1954 c-24 -9 -29 -13 -14 -13 11 -1 29 6 40 14 22 17 20 17
-26 -1z"/>
<path d="M7240 1960 c0 -9 39 -25 45 -18 2 2 -7 8 -21 15 -13 6 -24 7 -24 3z"/>
<path d="M7326 1955 c-11 -8 -15 -15 -9 -15 6 0 16 7 23 15 16 19 11 19 -14 0z"/>
<path d="M7885 1960 c-3 -5 -18 -11 -33 -11 -23 -2 -24 -2 -5 -6 13 -2 33 3
45 11 12 9 17 16 11 16 -7 0 -15 -4 -18 -10z"/>
<path d="M8490 1966 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
<path d="M9027 1963 c-10 -9 -9 -23 1 -23 5 0 9 7 9 15 0 17 -1 18 -10 8z"/>
<path d="M4509 1947 c5 -5 19 -7 32 -5 20 3 19 5 -9 9 -20 3 -29 2 -23 -4z"/>
<path d="M5045 1950 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M7995 1950 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M3848 1943 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M4378 1943 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
</g>
</svg>



    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
